import React from "react";
import "./ContactSection.css";
import { useTranslation } from "react-i18next";

import contactIcon from "../Assets/contact-icon.png";
import callPerson from "../Assets/call-person.png";

export default function ContactSection({ id }) {
  const { t } = useTranslation();

  return (
    <section id={id} className="cm-contact-wrapper">
      <div className="cm-contact-container">
        {/* RIGHT SIDE FORM */}
       <div className="cm-contact-right" style={{ width: "100%" }}>
          <form className="cm-contact-form">

            <div className="cm-form-row">
              <div className="cm-form-group">
                <label>{t("contact_form_name")}</label>
                <input type="text" placeholder={t("contact_form_name_placeholder")} />
              </div>

              <div className="cm-form-group">
                <label>{t("contact_form_email")}</label>
                <input type="email" placeholder={t("contact_form_email_placeholder")} />
              </div>
            </div>

            <div className="cm-form-row">
              <div className="cm-form-group">
                <label>{t("contact_form_phone")}</label>
                <input type="text" placeholder={t("contact_form_phone_placeholder")} />
              </div>

              <div className="cm-form-group">
                <label>{t("contact_form_subject")}</label>
                <select>
                  <option value="complaint">{t("contact_form_subject_complaint")}</option>
                  <option value="feedback">{t("contact_form_subject_feedback")}</option>
                </select>
              </div>
            </div>

            <div className="cm-form-group cm-form-full">
              <label>{t("contact_form_message")}</label>
              <textarea placeholder={t("contact_form_message_placeholder")}></textarea>
            </div>

            <p className="cm-form-note">{t("contact_form_note")}</p>

            <button className="cm-submit-btn">{t("contact_form_submit")}</button>
          </form>
        </div>

      </div>
    </section>
  );
}
